import { createFileRoute, redirect } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

const searchSchema = z.object({
  producer: z.string().optional(),
  page: z.number().int().positive().optional(),
});

export const Route = createFileRoute(
  "/_auth/settings/$siteId/_zeroAdmin/notification-rejects/",
)({
  validateSearch: zodValidator(searchSchema),
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: "/settings/$siteId/notifications",
      params: { siteId: params.siteId },
      search: { tab: "rejects", producer: search.producer, page: search.page },
      replace: true,
    });
  },
});
